    angular.module('navbars', ['auth'])
        .directive('menuToggle', function () {
            return {
                restrict: 'EA',
                link: function (scope, elem, attrs) {
                    scope.body = document.getElementsByTagName("body");
                    const topMenu = angular.element(document.getElementById('menu-top'));
                    const topToggleButton = angular.element(document.querySelector('[menu-top-toggle]'));

                    elem.bind('click', () => {
                        let isMenuOpen = angular.element(scope.body).hasClass('menu-open');
                        let isMenuClosed = angular.element(scope.body).hasClass('menu-closed');
                        let isMobileWidth = window.innerWidth < 481;

                        if (isMobileWidth) {
                            topMenu.removeClass('in');
                            topToggleButton.addClass('collapsed');
                            topToggleButton.attr('aria-expanded', 'false');
                        }

                        if (!isMenuOpen && !isMenuClosed) {
                            isMenuOpen = !isMobileWidth;
                        }
                        if (isMenuOpen) {
                            angular.element(scope.body).removeClass('menu-open');
                            angular.element(scope.body).addClass('menu-closed');
                        }
                        else {
                            angular.element(scope.body).addClass('menu-open');
                            angular.element(scope.body).removeClass('menu-closed');
                        }
                    });
                }
            };
        })
        .directive('navCollapse', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    let visible = false;

                    element.on('show.bs.collapse', () => visible = true);
                    element.on("hide.bs.collapse", () => visible = false);

                    element.on('click', event => {
                        if (visible && 'auto' === element.css('overflow-y') && $(event.target).attr('data-toggle') !== "dropdown" && event.target.tagName === "A") {
                            element.collapse('hide');
                        }
                    });
                }
            };
        })
        .directive('menuTopToggle', function () {
            return {
                restrict: 'A',
                link: function (scope, elem) {
                    const target = angular.element(document.getElementById('menu-top'));
                    const body = angular.element(document.getElementsByTagName('body'));

                    function syncButtonState() {
                        const expanded = target.hasClass('in');
                        elem.toggleClass('collapsed', !expanded);
                        elem.attr('aria-expanded', expanded ? 'true' : 'false');
                    }

                    elem.on('click', event => {
                        event.preventDefault();
                        event.stopPropagation();

                        if (window.innerWidth >= 768) {
                            return;
                        }

                        body.removeClass('menu-open');
                        body.addClass('menu-closed');

                        if (target.hasClass('in')) {
                            target.removeClass('in');
                        } else {
                            target.addClass('in');
                        }

                        syncButtonState();
                    });

                    scope.$on('$destroy', () => elem.off('click'));
                    syncButtonState();
                }
            };
        })
        .directive('menuTopCollapseOnMobile', function () {
            return {
                restrict: 'A',
                link: function (scope, element) {
                    const toggleButton = angular.element(document.querySelector('[menu-top-toggle]'));
                    let touchStartX = null;
                    let touchStartY = null;
                    let touchMoved = false;

                    function closeMenu() {
                        if (window.innerWidth >= 768) {
                            return;
                        }

                        element.removeClass('in');
                        toggleButton.addClass('collapsed');
                        toggleButton.attr('aria-expanded', 'false');
                    }

                    element.on('touchstart', event => {
                        if (window.innerWidth >= 768) {
                            return;
                        }

                        const touch = event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : event.touches[0];
                        touchStartX = touch ? touch.clientX : null;
                        touchStartY = touch ? touch.clientY : null;
                        touchMoved = false;
                    });

                    element.on('touchmove', event => {
                        if (window.innerWidth >= 768 || touchStartX == null || touchStartY == null) {
                            return;
                        }

                        const touch = event.originalEvent && event.originalEvent.touches ? event.originalEvent.touches[0] : event.touches[0];
                        if (!touch) {
                            return;
                        }

                        if (Math.abs(touch.clientX - touchStartX) > 8 || Math.abs(touch.clientY - touchStartY) > 8) {
                            touchMoved = true;
                        }
                    });

                    element.on('click', event => {
                        if (window.innerWidth >= 768) {
                            return;
                        }

                        if (touchMoved) {
                            touchMoved = false;
                            return;
                        }

                        const target = $(event.target);
                        const trigger = target.closest('a');
                        const dropdownToggle = target.closest('[uib-dropdown-toggle]');
                        if (trigger.length > 0 && dropdownToggle.length === 0) {
                            closeMenu();
                        }
                    });

                    angular.element(window).on('resize', closeMenu);
                    scope.$on('$destroy', () => {
                        element.off('touchstart');
                        element.off('touchmove');
                        element.off('click');
                        angular.element(window).off('resize', closeMenu);
                    });
                }
            };
        })
        .directive('menuAutoCollapseOnMobile', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    scope.body = document.getElementsByTagName("body");

                    element.on('click', event => {
                        let isMenuOpen = angular.element(scope.body).hasClass('menu-open');
                        let isMenuClosed = angular.element(scope.body).hasClass('menu-closed');
                        let isMobileWidth = window.innerWidth < 481;

                        if (!isMenuOpen && !isMenuClosed) {
                            isMenuOpen = !isMobileWidth;
                        }

                        if (isMenuOpen && isMobileWidth && $(event.target).attr('data-toggle') !== "dropdown") {
                            angular.element(scope.body).removeClass('menu-open');
                            angular.element(scope.body).addClass('menu-closed');
                        }
                    });
                }
            };
        })
        .controller('NavbarTopCtrl', function ($scope, $state, Auth, Principal, modals, DashboardSwitcher) {
            $scope.isAuthenticated = null
            $scope.currentAccount = null

            $scope.logout = () => Auth.logout()
            $scope.exitUser = () => Auth.exitUser().then(() => $state.go('home', {}, {reload: true}))

            $scope.openVersionInfo = () => {
                return modals.open('app/dashboard/navbar/about.html', 'NavbarAboutController', null, {size: 'sm'}, "$ctrl")
            }

            $scope.dashboards = DashboardSwitcher.dashboards()
            $scope.setDefaultDashboard = dash => {
                DashboardSwitcher.setTemplate(dash)
                $state.go('home', {}, {reload: true})
            }

            $scope.$on('authenticationSuccess', () => getAccount())

            getAccount()

            function getAccount() {
                Principal.identity().then(account => {
                    $scope.currentAccount = account
                    $scope.isAuthenticated = Principal.isAuthenticated
                });
            }
        })
        .controller('NavbarAboutController', function ($http, $uibModalInstance) {
            this.$onInit = () => {
                $http.get("/crm/api/tenant").then(tenant => this.tenant = tenant.data)
            }
            this.cancel = () => $uibModalInstance.dismiss('cancel')
        })
        .factory('NavbarLeftMenu', function ($rootScope) {
            let _items = []

            function add(item) {
                _items.push(item)
                $rootScope.$broadcast('navbar-left-menu.changed')
            }

            function updateCount(path, count){
                let item = _items.find(it => it.path === path);
                if(item){
                    item.counter = count;
                }
            }

            return {
                add: add,
                updateCount: updateCount,
                items: _items
            };
        })
        .run(function (NavbarLeftMenu) {
            NavbarLeftMenu.add({
                authorities: "ROLE_USER",
                path: "/",
                ico: "fa fa-fw fa-tachometer",
                name: 'menu.mainpanel',
                order: 1
            });
        })
        .controller('NavbarLeftCtrl', function ($scope, $interval, $filter, NavbarLeftMenu, PublicSettingsService) {
            $scope.menuItems = visibleMenuItems({})
            refreshMenuItems()

            $scope.$on('menu.counter.changed', event => {
                console.log('menu.counter.changed', event)
            });
            let unwatchMenuChanged = $scope.$on('navbar-left-menu.changed', refreshMenuItems)
            $scope.$on('$destroy', unwatchMenuChanged)

            function refreshMenuItems() {
                return PublicSettingsService.get().then(settings => $scope.menuItems = visibleMenuItems(settings))
            }

            function visibleMenuItems(settings) {
                const features = settings.features || {}
                return NavbarLeftMenu.items.filter(item => !item.featureToggle || features[item.featureToggle] === true)
            }
            // $scope.menuItems.filter(it => it.counterFn != null).map(item => {
            //     intervalPromise = $interval(item.counterFn, 20000)
            //     return intervalPromise;
            // })
            //
            // let intervalPromise
            // function initAutoRefresh() {
            //     $interval.cancel(intervalPromise);
            //
            //     intervalPromise = $interval(initAutoRefresh, 60000)
            // }
            //
            // $scope.$on('$destroy', () => $interval.cancel(intervalPromise))
        })
